import { Button, Inline } from '@etg/wings';
import { variants } from '@eti/components';
import { css } from '@eti/styles';
import { useTranslation } from '@eti/providers';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const wrapperStyles = css`
  bottom: 0;
  left: 0;
  padding: 10px;
  position: fixed;
  width: 100%;
`;
const footerButtonStyles = isFirstSegment => css`
  justify-content: ${isFirstSegment ? 'flex-end' : 'space-between'};
`;
const SeatMapFooter = _ref => {
  let {
    onClose,
    onSaveAndContinue,
    shouldShowSummary,
    isFirstSegment,
    handlePreviousSegmentClick
  } = _ref;
  const {
    t
  } = useTranslation();
  const saveAndContinueLabel = t('Product.SeatMap.Button.Continue');
  const segmentBackLabel = t('Button.Text.Back');
  const handleClose = e => {
    if (!shouldShowSummary) {
      onSaveAndContinue(e);
      return;
    }
    onClose(e);
  };
  return /*#__PURE__*/_jsx("div", {
    className: wrapperStyles,
    "data-testid": "seatMapFooter",
    children: /*#__PURE__*/_jsxs(Inline, {
      className: footerButtonStyles(isFirstSegment),
      children: [!isFirstSegment && /*#__PURE__*/_jsx(Button, {
        "data-testid": "segment-back-button",
        onClick: handlePreviousSegmentClick,
        variant: variants.SECONDARY,
        children: segmentBackLabel
      }), /*#__PURE__*/_jsx(Button, {
        "data-testid": "saveAndContinue-button",
        onClick: handleClose,
        variant: variants.PRIMARY,
        children: saveAndContinueLabel
      })]
    })
  });
};
export default SeatMapFooter;
//# sourceMappingURL=SeatMapFooter.js.map